module.exports = __webpack_public_path__ + "static/media/knife.6ecb1e01.png";